// extracted by mini-css-extract-plugin
module.exports = {"main":"LinkButton_main__2qLdt","disabled":"LinkButton_disabled__2axcX"};